import { useState, type FormEvent } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Box, TextField, Button, Typography, Alert, CircularProgress } from '@mui/material';
import { ArrowBack, Email as EmailIcon } from '@mui/icons-material';
import { useForgotPassword } from '../../application/useForgotPassword';
import AuthCardLayout from './AuthCardLayout';

/** UC-2: usa useForgotPassword (T25). Textos hardcodeados en español preservados (C-1). */
export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const { error, success, loading, submit } = useForgotPassword();
  const [email, setEmail] = useState('');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    submit(email);
  };

  return (
    <AuthCardLayout title="Restablecer Contraseña">
      {success ? (
        <>
          <Alert severity="success" sx={{ mb: 2 }}>
            Si el correo está registrado, recibirás un enlace para restablecer tu contraseña. Revisa
            tu bandeja de entrada y spam.
          </Alert>
          <Button
            fullWidth
            variant="outlined"
            startIcon={<ArrowBack />}
            onClick={() => navigate('/login')}
            sx={{ mt: 2 }}
          >
            Volver al Login
          </Button>
        </>
      ) : (
        <>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Ingresa el correo electrónico asociado a tu cuenta. Te enviaremos un enlace para
            restablecer tu contraseña.
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Correo electrónico"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              autoComplete="email"
              disabled={loading}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : <EmailIcon />}
              sx={{ mt: 3, py: 1.5 }}
            >
              {loading ? 'Enviando...' : 'Enviar enlace'}
            </Button>
          </form>

          <Box sx={{ textAlign: 'center', mt: 2 }}>
            <Button component={Link} to="/login" startIcon={<ArrowBack />} size="small">
              Volver al Login
            </Button>
          </Box>
        </>
      )}
    </AuthCardLayout>
  );
}
